<div class="flxClmn bs-enabled" style="width: 100%; height: 100%;">
	<div class="flex-row gap-5" style="align-items: center; margin-bottom: 2rem;">
		<ng-container *ngFor="let event of trackingEvents">
			<div class="flex-column align-items-center tracking-icn-container"
				 [ngClass]="{'active': getTrackingStatus(event.name) === 'success',
							 'current': getTrackingStatus(event.name) === 'failed' || event.name === 'Blocked',
							 'not-active': getTrackingStatus(event.name) === 'none'}">
				<div class="tracking-icon" [ngClass]="{'first': event.isFirst, 'last': event.isLast}">
					<i class="{{ event.icon }}"></i>
				</div>
				<span>{{ event.label }}</span>
			</div>
		</ng-container>

		<ng-template #trackingTemplate let-event="event">
			<div class="flex-column align-items-center tracking-icn-container"
				 [ngClass]="{'active': getTrackingStatus(event.name) === 'success',
							 'current': getTrackingStatus(event.name) === 'failed' || event.name === 'Blocked',
							 'not-active': getTrackingStatus(event.name) === 'none'}">
				<div class="tracking-icon" [ngClass]="{'first': event.isFirst, 'last': event.isLast}">
					<i class="{{ event.icon }}"></i>
				</div>
				<span>{{ event.label }}</span>
			</div>
		</ng-template>
	</div>

	<trustifi-table-c *ngIf="recipientTrack?.track_events?.length" class="trustifi-table f-1-0" style="z-index: 4; min-height: 330px;"
		  [list]="recipientTrack.track_events"
		  [headers]="[
			{text: 'Created', sortKey: 'created', width: '150px'},
			{text: 'Event', sortKey: 'name', width: '175px'},
			{text: 'Description'}
		  ]"
		  [cellsPrototype]="[
			{textKey: 'created', textType: 'dateAndTime'},
			{html: 'nameCell'},
			{html: 'infoCell'}
		  ]"
		  [options]="{
				hideCounter: true,
				defaultSortKey: '-created',
			}">

		<ng-template #customCells let-item let-cellId="cellId">
			<!--name cell-->
			<div *ngIf="cellId === 'nameCell'">
				<div class="flex-row hSpace05" [ngStyle]="item.ll ? {'align-items' : 'end'} : {}">
					<span>{{item.name}}</span>
					<img *ngIf="(item.name == 'Read' || item.name == 'Opened') && item.ll" (click)="openLocation(item.ll)" title="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
				</div>
			</div>
			<!--Info cell-->
			<div *ngIf="cellId === 'infoCell'">
				<ul style="list-style: none; padding-left: 0; margin: 0;">
					<li *ngFor="let event of item.info;" style="font-size: 12px;">{{event.msg}}</li>
				</ul>
			</div>
		</ng-template>
	</trustifi-table-c>
</div>
